module.exports = __webpack_public_path__ + "static/ident_pin-44d9739aee5b7c556c3c57d4a5c9ec16.jpg";